import type { Registry as Services } from '@ember/service';
import type { Period } from 'lumen/models';
import { calculateTotalRoomsForSale } from 'lumen/utils/pricing-assistant/dynamic-rate-pricing-utils';

type DataRequestService = Services['pricing-assistant-data-request-service'];

export interface LeftToSellValues {
  leftToSell: number | null;
  overbooking: number | null;
}

/* The left to sell and the overbooking it includes: the hotel's, or
   the room's with its PMS id. A failed request leaves no availability record for
   the date, so left to sell is null, as it is while the overbooking is unknown. */
export function resolveLeftToSellValues(
  period: Period,
  pmsRoomId?: string,
): LeftToSellValues {
  const { day } = period;
  const occupancy =
    pmsRoomId === undefined ? day.occupancy : day.roomOccupancy(pmsRoomId);
  const availableRooms = occupancy?.availableRooms ?? null;
  /* TODO: read the room's overbooking override, like the hotel level, once
     room-level overbooking overrides exist. */
  const overbooking =
    pmsRoomId !== undefined
      ? period.roomOverbooking(pmsRoomId)
      : period.effectiveOverbookingWithOverride;

  return {
    leftToSell:
      availableRooms == null || overbooking == null
        ? null
        : calculateTotalRoomsForSale(availableRooms, overbooking),
    overbooking,
  };
}

/* Whether the request behind the available rooms runs: the room availability for
   a room, the general data (which holds the OTB) for the hotel level. */
export function isOccupancyLoading(
  dataRequestService: DataRequestService,
  pmsRoomId?: string,
): boolean {
  return pmsRoomId === undefined
    ? dataRequestService.pricingAssistantGeneralDataRequestsTask.isRunning
    : dataRequestService.roomOccupancyRequestTask.isRunning;
}
